<template>
  <div
    v-if="isVisible"
    class="privacy-policy-confirm"
  >
    <div class="privacy-policy-confirm__message">
      Пользуясь сайтом, вы соглашаетесь с использованием cookies и <a href="/policy" target="_blank">политикой конфиденциальности</a>.<br/>
      😅 Мы знаем, что окно мешает — закон обязывает предупредить. Нажмите “Хорошо” и окно исчезнет!
    </div>
    <div class="privacy-policy-confirm__button">
      <button class="btn btn-primary" @click="confirmCookie">
        Хорошо
      </button>
    </div>
  </div>
</template>

<script lang="ts" setup>
const isVisible: Ref<boolean> = ref(false);

const checkCookie = () => {
  const confirmUseCookie: any = useCookie('confirm_use_cookie', {
    maxAge: (60 * 60 * 24 * 30 * 12)
  });
  const _isVisible: boolean = !Boolean(confirmUseCookie?.value);
  if (!_isVisible) {
    return
  }

  setTimeout(() => {
    isVisible.value = _isVisible;
  }, 11000)
}
const confirmCookie = () => {
  const confirmUseCookie: any = useCookie('confirm_use_cookie', {
    maxAge: (60 * 60 * 24 * 30 * 12)
  });
  confirmUseCookie.value = String(true);
  isVisible.value = false;
}
onMounted(() => {
  checkCookie();
});
</script>

<style scoped lang="scss">
.privacy-policy-confirm {
  width: auto;
  z-index: 600;
  padding: 15px;
  position: fixed;
  max-width: 366px;
  background: white;
  border-radius: 4px;
  box-sizing: border-box;
  bottom: 10px; left: 10px;
  box-shadow: 0px 4px 8px 0px #00000059;
}
.privacy-policy-confirm__message {
  font-size: 13px;
  line-height: 1.4;

  a {
    color: #404040;
    transition: all 0.3s;
    text-decoration-line: underline;
    &:hover {
      text-decoration-color: transparent;
    }
  }
}
.privacy-policy-confirm__button {
  margin-top: 8px;
  .btn {
    height: auto;
    min-height: initial;
    padding: 4px 16px;
    border-radius: 6px;
    font-size: 13px;
    line-height: 15px;
  }
}

@media (max-width: 639px) {
  .privacy-policy-confirm {
    bottom: 48px;
  }
}
</style>
